import React from "react";
import { motion } from "framer-motion";
import testimonios from "../../data/testimonios.json";
/**
 * TestimonialsMarquee.jsx
 * React component (JSX) using Framer Motion + TailwindCSS
 * - Muestra testimonios en doble fila con desplazamiento infinito
 * - Fila superior se desplaza hacia la izquierda, fila inferior hacia la derecha
 * - Extensión: .jsx
 *
 * Props:
 * - testimonials: array de objetos { id, name, role, text }
 * - topDuration, bottomDuration: duración en segundos (controlan velocidad)
 */

const Testimonios = testimonios;


function TestimonialCard({ t }) {
  return (
    <article
      role="listitem"
      className="w-72 sm:w-[400px] lg:w-[500px] h-[300px] md:h-[250px] flex flex-col justify-center bg-gray-100 p-4 rounded-2xl  mr-4 select-none rounded-[15px]"
      aria-label={`Testimonio de ${t.nombre}`}
    >
      <p className="text-sm sm:text-base text-primario hyphens-none">“{t.testimonio}”</p>
      <div className="mt-3 flex items-center justify-start gap-4">
        <div className="w-12 h-12 md:w-14 md:h-14 border-blue-4 border-2 rounded-full bg-yellow-4 overflow-hidden">
          <img
            src={t.imagen}
            alt="lo que dicen nuestros estudiantes de Brighton Centro de Inglés"
            className="object-cover object-center w-full h-full"
          />
        </div>
        <div>
          <p className="font-semibold text-sm md:text-base text-primario">{t.nombre}</p>
          <p className="text-sm text-gray-950">{t.rol}</p>
        </div>
      </div>
    </article>
  );
}

function MarqueeRow({ items, duration = 20, reverse = false, ariaLabel }) {
  // Duplicate items to create seamless loop
  const displayed = [...items, ...items];

  // animate x from 0% to -50% (or 0% to 50%) so duplicated content scrolls seamlessly
  const from = reverse ? "-50%" : "0%";
  const to = reverse ? "0%" : "-50%";

  return (
    <div className="w-full overflow-hidden">
      <motion.div
        className="inline-flex items-start"
        aria-label={ariaLabel}
        animate={{ x: [from, to] }}
        transition={{
          repeat: Infinity,
          repeatType: "loop",
          ease: "linear",
          duration,
        }}
      >
        {displayed.map((t, i) => (
          <div key={`${t.id}-${i}`} className="">
            <TestimonialCard t={t} />
          </div>
        ))}
      </motion.div>
    </div>
  );
}




export default function TestimonialsMarquee({
  testimonials = Testimonios,
  topDuration = 230,
  bottomDuration = 230,
  className = "min-h-screen",
}) {
  return (
    <div
      className={`w-full py-8  ${className}`}
      aria-label="Testimonios de estudiantes Brighton"
      role="region"
    >
      <div className="w-full">
        <h2 className="text-xl sm:text-2xl lg:text-6xl text-primario font-semibold mb-4 text-center font-Bebas">
          Lo que dicen nuestros estudiantes
        </h2>

        {/* Fila superior: se mueve hacia la izquierda */}
        <div className="mb-6" >
          <MarqueeRow
            items={testimonials}
            duration={topDuration}
            reverse={false}
            ariaLabel="Fila de testimonios desplazándose a la izquierda"
          />
        </div>

        {/* Fila inferior: se mueve hacia la derecha */}
        <div>
          <MarqueeRow
            items={testimonials}
            duration={bottomDuration}
            reverse={true}
            ariaLabel="Fila de testimonios desplazándose a la derecha"
          />
        </div>
      </div>
    </div>
  );
}
